var map = {
	"./剩余电量-中低电量.png": 5699,
	"./剩余电量-中高电量.png": 3281,
	"./剩余电量-低电量.png": 3142,
	"./剩余电量-电量充足.png": 9482,
	"./组 15.png": 3144,
	"./组 25.png": 9866,
	"./组 52.png": 8056,
	"./组 53.png": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9459;